import { createApiSaga } from '../sagaGenerator';
import { apiGet } from '../../middleware/api';
import {
  EFFECTS_DESCRIPTOR_DAMAGE_REQUEST,
  EFFECTS_DESCRIPTOR_DAMAGE_SUCCESS,
  EFFECTS_DESCRIPTOR_DAMAGE_FAILURE,
  EFFECTS_DESCRIPTOR_HOUSES_SUCCESS,
  EFFECTS_DESCRIPTOR_HOUSES_REQUEST,
  EFFECTS_DESCRIPTOR_HOUSES_FAILURE,
  EFFECTS_DESCRIPTOR_PEOPLE_REQUEST,
  EFFECTS_DESCRIPTOR_PEOPLE_SUCCESS,
  EFFECTS_DESCRIPTOR_PEOPLE_FAILURE,
} from './effectDescriptorReducer';

const getPeopleSaga = createApiSaga({
  apiFunction: apiGet,
  generateApiConfig: action => ({ endpoint: '/descriptors/effect/people', ...action }),
  requestType: EFFECTS_DESCRIPTOR_PEOPLE_REQUEST,
  successType: EFFECTS_DESCRIPTOR_PEOPLE_SUCCESS,
  failureType: EFFECTS_DESCRIPTOR_PEOPLE_FAILURE,
});

const getHousesSaga = createApiSaga({
  apiFunction: apiGet,
  generateApiConfig: action => ({ endpoint: '/descriptors/effect/houses', ...action }),
  requestType: EFFECTS_DESCRIPTOR_HOUSES_REQUEST,
  successType: EFFECTS_DESCRIPTOR_HOUSES_SUCCESS,
  failureType: EFFECTS_DESCRIPTOR_HOUSES_FAILURE,
});

const getDamageSaga = createApiSaga({
  apiFunction: apiGet,
  generateApiConfig: action => ({ endpoint: '/descriptors/effect/damage', ...action }),
  requestType: EFFECTS_DESCRIPTOR_DAMAGE_REQUEST,
  successType: EFFECTS_DESCRIPTOR_DAMAGE_SUCCESS,
  failureType: EFFECTS_DESCRIPTOR_DAMAGE_FAILURE,
});


export const effectDescriptorSagas = [
  getPeopleSaga,
  getHousesSaga,
  getDamageSaga,
];
